import { useState } from 'react';
import { Link } from 'react-router-dom';
import { makeRequest } from "../../utils/axios.js"; 
import '../forgotPassword/forgotPassword.scss';
import NetworkingVideo from '../../assets/Networking.mp4';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErr(null);
    setMsg(null);

    try {
      const res = await makeRequest.post("/auth/forgot-password", { email });
      setMsg(res.data); 
    } catch (error) {
      const errorMessage = error.response?.data?.error 
                         || error.response?.data?.message 
                         || (typeof error.response?.data === 'string' ? error.response?.data : "Something went wrong!");
      setErr(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='forgotPassword'>
      <video autoPlay loop muted playsInline className="video-background">
        <source src={NetworkingVideo} type="video/mp4" />
      </video>

      <div className="video-overlay"></div>

      <div className="card">
        <div className="left">
          <h1>
            Don't Panic.
          </h1>

          <p>
            Enter the email address associated with your account, and we'll send you a link to reset your password.
          </p>

          <span>
            Remember your password?
          </span>

          <Link to="/login">
            <button>
              Back to Login
            </button>
          </Link>
        </div>

        <div className="right">
          <h1>
            Forgot Password
          </h1>
          
          {msg ? (
             <div className="success-message">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.76 11.7574L11.0026 16Z">
                    </path>
                </svg>

                <span>
                  {msg}
                </span>
             </div>
          ) : (
            <form onSubmit={handleForgotPassword}>
              <input 
                type='email' 
                placeholder='Enter your email' 
                onChange={(e) => setEmail(e.target.value)} 
                required
              />

              {err && 
                <div className="error-message">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                      <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z">
                      </path>
                  </svg>

                  <span>
                    {err}
                  </span>
                </div>
              }

              <button type="submit" disabled={isLoading}>
                {isLoading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;